import { render, staticRenderFns } from "./head-tabs.vue?vue&type=template&id=a15c8568&scoped=true"
import script from "./head-tabs.vue?vue&type=script&lang=js"
export * from "./head-tabs.vue?vue&type=script&lang=js"
import style0 from "./head-tabs.vue?vue&type=style&index=0&id=a15c8568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15c8568",
  null
  
)

export default component.exports